import React, { useState, useEffect } from 'react'
import { Accordion, Card } from 'react-bootstrap'
import ProfileModal from '../../../TransporterClientScreen/ProfileModal/ProfileModal';
//import Autosuggestor from '../../AutoComplete/AutoCompleteTransporter';
import Autocomplete from '../../AutoComplete/AutocompletetransporterV2';


/**
 * Represents the transporter management component within an auction.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Array} props.auction_list - The list of auctions containing transporters.
 * @param {Function} props.setauction_list - Function to update the auction list.
 * @param {Array} props.procurement_level_list - The list of transporters at procurement level.
 * @param {Function} props.setprocurement_level_list - Function to update the procurement level list.
 * @returns {React.ReactElement} The transporter management component.
 */
const Transporter = ({
    auction_list = [],
    setauction_list = [],
    procurement_level_list = [],
    setprocurement_level_list = []
}) => {
    const [auctionList, setAuctionList] = useState([])
    const [searchText, setSearchText] = useState('')

    /**
     * Initializes the auction list when the component mounts.
     *
     * @hook
     * @returns {void}
     */
    useEffect(() => {
        var temp = auction_list.map((auction) => {
            auction.transporter_list.map((transporter) => {
                return transporter
            });
            return auction
        })
        setauction_list(temp)
        setAuctionList(temp)
    }, [])

    /**
     * Handles changes in the transporter selection within an auction.
     *
     * @param {Object} e - The event object.
     * @param {Object} transporter - The transporter being updated.
     * @param {Object} auction - The auction containing the transporter.
     * @returns {void}
     */
    const transporterchangeHandler = (e, transporter, auction) => {
        var temp = auctionList.map((temp_auction) => {
            if (temp_auction.auction_id === auction.auction_id) {
                temp_auction.transporter_list = temp_auction.transporter_list.map((temp_transporter) => {
                    if (temp_transporter.transporter_id === transporter.transporter_id) {
                        temp_transporter.ischecked = e.target.checked
                    }
                    return temp_transporter
                })
            }
            return temp_auction
        })
        setauction_list(temp)
    }

    /**
     * Checks if a transporter is present in the list.
     *
     * @param {Array} list - The list of transporters.
     * @param {Object} e - The transporter to check for.
     * @returns {boolean} True if the transporter is present, otherwise false.
     */
    const gettransporterproesent = (list, e) => {
        var val = false
        list.map((trans) => {
            if (trans.transporter_id === e.transporter_id) {
                val = true
            }
        })
        return val
    }

    /**
     * Adds a transporter to the list and updates the procurement level list.
     *
     * @param {Object} e - The transporter to add.
     * @param {Object} auction - The auction to which the transporter is being added.
     * @returns {void}
     */
    const addtolist = (e, auction) => {
        var temp = auctionList.map((temp_auction) => {
            if (auction.auction_id === temp_auction.auction_id) {
                e.ischecked = true
                if (!gettransporterproesent(temp_auction.transporter_list, e)) {
                    temp_auction.transporter_list.push(e)
                }
            }
            return temp_auction
        });
        setAuctionList(temp)
        setauction_list(temp)
        if (!gettransporterproesent(procurement_level_list, e)) {
            e.isProcurementLevel = true
            setprocurement_level_list([...procurement_level_list, e])
        }
        setSearchText('')
    };

    return (
        <div>
            {auctionList && auctionList.length > 0 ?
                <Accordion defaultActiveKey="0">
                    {auctionList.map((auction, index) => {
                        return <Card key={auction.auction_id}>
                            <Accordion.Toggle as={Card.Header} eventKey={`${index}`}>
                                {auction.auction_description}
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={`${index}`}>
                                <div style={{ overflow: 'auto', maxHeight: '55vh' }}>
                                    <div className='autosuggest_div' style={{ marginTop: '5px' }}>
                                        <Autocomplete
                                            placeholder="Add Transporters"
                                            value={searchText}
                                            onChange={(val) => setSearchText(val)}
                                            onSelect={(transporter) =>
                                                setSearchText(transporter?.transporter_name || "")
                                            }
                                            getResults={(transporter) => addtolist(transporter, auction)}
                                            type="transporter"
                                        />
                                    </div>
                                    {auction.transporter_list && auction.transporter_list.length > 0 ?
                                        auction.transporter_list.map((transporter) => {
                                            return <div style={{ display: 'flex', padding: '0 3%' }} key={transporter.transporter_id}>
                                                <div style={{ alignSelf: 'center' }}>
                                                    <input
                                                        type="checkbox"
                                                        style={{ height: '15px', width: '15px' }}
                                                        checked={transporter.ischecked}
                                                        onChange={e => transporterchangeHandler(e, transporter, auction)}
                                                    />
                                                </div>
                                                <div style={{ flexBasis: '90%' }}>
                                                    <ProfileModal
                                                        transporter_id={transporter.transporter_id}
                                                        transporter_name={transporter.transporter_name}
                                                        transporter_list={procurement_level_list}
                                                        screenName={'LoRRI Adhoc'}
                                                        moduleName={'Adhoc to Auction'}
                                                    />
                                                </div>
                                            </div>
                                        })
                                        : <div>
                                            No Transporter's Selected
                                        </div>}
                                </div>
                            </Accordion.Collapse>
                        </Card>
                    })}
                </Accordion>
                : null}
        </div>
    );
}

export default Transporter;
